module Meevo.Plugins.Product {
	"use strict";
	import StorageTypeEnum = Meevo.Model.StorageTypeEnum;

	/**
	* Main Section of Client 
	*/
	export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.Product> {

		/**
		* Base class override which defines what a DEFAULT model looks like.
		*/
		createSectionModelInstance(postAdd: (data: any) => any): void {
			this.dataService.getTemplate("product").then((data) => {
				this.model = data;
				this.model.manufacturer = null;
				this.model.businessTypeDetail = null;
				this.model.productSubCategory = null;
				this.model["variants"][0]["markUp"] = 0; // needed for UI to prevent a "NaN" value from appearing
				this.model.variants[0]["variantStockLevels"][0].isDisplayed = true;
			});
		}

		get storageTypeEnum(): any {
			return StorageTypeEnum;
		}

		sectionModelRetrieved(): void {
			if (this.model && (this.model.variants == null || this.model.variants.length === 0)) {
				this.model.variants = [];
			}
		}
	}
}